var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-wrap"},[_c('div',{staticClass:"back",on:{"click":_vm.goBack}},[_vm._v("返回")]),_c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"none"},attrs:{"src":_vm.iframeSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }